<template>
  <div
    :class="
      $style['promotion']
    "
    @click="onClick">
    <div
      :class="
        $style['promotion__background-one']
      " />
    <div
      :class="
        $style['promotion__text']
      " />
    <div
      :class="
        $style['promotion__background-two']
      "
      :style="localizedImage" />
    <div :class="$style['promotion__inner']">
      <Btn
        v-if="(promotionData.link && promotionData.showLink) && shouldShow(promotionData.link)"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"
        color="cta"
        shape="round" />
    </div>
  </div>
</template>
<script>
import baseScript from './Shared/script'
export default {
  extends: baseScript,
  setup () {
    const { $lang } = useNuxtApp()
    const localizedImage = computed(() => {
      return $lang === 'de' ? 'background-image: url(\'/images/promotions/easter-stack/background-de.webp\')' : 'background-image: url(\'/images/promotions/easter-stack/background-en.webp\')'
    })

    return { localizedImage }
  }
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  position: relative;

  &__background-one {
    position: absolute;
    width: 100%;
    aspect-ratio: 16 / 13;
    background-size: cover;
    background-image: url('/images/promotions/easter-stack/background.webp');
  }

  &__text {
    position: absolute;
    width: 100%;
    aspect-ratio: 16 / 13;
    background-size: cover;
    background-image: url('/images/promotions/easter-stack/text.svg');
  }

  &__background-two {
    position: absolute;
    width: 100%;
    aspect-ratio: 16 / 13;
    background-size: cover;

    animation-name: switch;
    animation-duration: 3s;
    animation-iteration-count: infinite;
  }
}

@keyframes switch {
  0% {
    opacity: 1;
  }

  49.99% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

</style>
